module.exports = __webpack_public_path__ + "static/media/1969440208_20190214_145129_2507217_resized.681bc340.JPG";